import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import LandingPage    from './pages/LandingPage';
import VocabApp       from './pages/VocabApp';
import RationalePage  from './pages/RationalePage';
import DonatePage     from './pages/DonatePage';
import { COLORS }     from './config';

function Nav() {
  const loc = useLocation();
  const links = [['/', 'Home'], ['/app', 'Learn'], ['/why', 'Why 81?'], ['/donate', 'Donate']];
  return (
    <nav style={{
      position:'sticky', top:0, zIndex:100,
      background:'rgba(250,252,251,0.92)', backdropFilter:'blur(12px)', WebkitBackdropFilter:'blur(12px)',
      borderBottom:`1px solid ${COLORS.border}`,
      display:'flex', alignItems:'center', gap:'4px', padding:'10px 20px',
    }}>
      <Link to="/" style={{
        fontWeight:800, color: COLORS.primary, textDecoration:'none',
        fontSize:'1rem', marginRight:'auto', letterSpacing:'-0.01em',
        fontFamily:"'Noto Serif Tamil', serif",
      }}>
        தமிழ் <span style={{fontSize:'0.75rem', fontWeight:500, color: COLORS.textMuted, fontFamily:"'Plus Jakarta Sans', sans-serif"}}>tamizh.fun</span>
      </Link>
      {links.map(([path, label]) => (
        <Link key={path} to={path} style={{
          padding:'8px 14px', borderRadius:'8px', textDecoration:'none',
          fontSize:'0.8125rem', fontWeight: loc.pathname===path ? 700 : 500,
          background: loc.pathname===path ? COLORS.primaryLight : 'transparent',
          color: loc.pathname===path ? COLORS.primary : COLORS.textMuted,
          transition:'all 0.2s cubic-bezier(0.16,1,0.3,1)',
          whiteSpace:'nowrap',
        }}>{label}</Link>
      ))}
    </nav>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Routes>
        <Route path="/"       element={<LandingPage />} />
        <Route path="/app"    element={<VocabApp />} />
        <Route path="/why"    element={<RationalePage />} />
        <Route path="/donate" element={<DonatePage />} />
      </Routes>
    </BrowserRouter>
  );
}
